import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import ThemeToggle from './components/ThemeToggle';
import ConstellationBackground from './components/ConstellationBackground';
import Solutions from './components/Solutions';
import Contact from './components/Contact';
import Footer from './components/Footer';
import About from './components/About';
import Staff from './components/Staff';
import Blog from './components/Blog';
import Press from './components/Press';
import HelpCenter from './components/HelpCenter';
import Home from './components/Home';
import NotFound from './components/NotFound';

const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');

    if (savedTheme === 'dark') setDarkMode(true);
  }, []);

  useEffect(() => {
    if (darkMode) document.body.classList.add('dark');
    
    else document.body.classList.remove('dark');

    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  useEffect(() => {
    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.animate');
      const windowHeight = window.innerHeight;

      elements.forEach(element => {
        const elementPosition = element.getBoundingClientRect().top;
        const offset = 100;

        if (elementPosition < windowHeight - offset) {
          element.style.opacity = '1';
          element.style.transform = 'translateY(0)';
        }
      });
    };

    animateOnScroll();

    window.addEventListener('scroll', animateOnScroll);

    return () => window.removeEventListener('scroll', animateOnScroll);
  }, []);

  return (
    <div className='min-h-screen font-manrope text-gray-900 dark:text-gray-200 transition-all duration-300'>
      <ConstellationBackground darkMode={darkMode} />
      <Header />
      <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/solutions' element={<Solutions />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />
        <Route path='/staff' element={<Staff />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/press' element={<Press />} />
        <Route path='/help-center' element={<HelpCenter />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
